import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterInvestigationUpdatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDiffList,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterInvestigationUpdatedEventProps {
  event: DiscriminatedMatterInvestigationUpdatedEvent;
}

export const MatterInvestigationUpdatedEvent: React.FC<
  MatterInvestigationUpdatedEventProps
> = ({ event }) => {
  const user = getUserFromEvent(event);
  const { diff } = event.payload;

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-gray-100">
          <PencilIcon className="h-4 w-4 text-gray-600" />
        </div>
      }
    />
  );

  const body = diff && (
    <ActivityBody>
      <ActivityDiffList diff={diff} defaultExpanded={false} />
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Investigation Updated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
